export default __webpack_public_path__ + "static/drinks-063371a9bd680aafa1378ae0bf147b0b.png";